import { LeaderboardRankRow } from "./LeaderboardRankRow";
import type { LeaderboardItem } from "./types";

type Props = {
	items: LeaderboardItem[];
	currentUsername?: string;
};

export const LeaderboardList = ({ items, currentUsername }: Props) => (
	<>
		{items.map((item, index) => (
			<LeaderboardRankRow
				key={item.rank}
				{...item}
				isCurrentUser={
					currentUsername !== undefined && item.username === currentUsername
				}
				showDivider={index < items.length - 1}
			/>
		))}
	</>
);
